import React from 'react';

export const DynamicFormContext = React.createContext({
  providers: {
    events: {},
  },
  initialValues: {},
});
